import { useUserMedia } from "@/utils";
import { createContext } from "react";

export const UserMediaContext = createContext<ReturnType<typeof useUserMedia>>({
  error: null,
  initializeCamera: async () => {},
  mediaStream: null,
  closeCamera: () => {},
  isLoading: false,
});
